@if (displayMultiSelect === true) {
  <div class="grid grid-cols-2 gap-3">
    <div class="col-span-2 @lg:col-span-1">
      <label class="text-sm">Packing&nbsp;year</label>
      <ng-select
        id="year"
        [(ngModel)]="displayYear"
        [ngModelOptions]="{ standalone: true }"
        [items]="years"
        bindLabel="value"
        bindValue="value"
        [multiple]="false"
        [searchable]="false"
        [virtualScroll]="true"
        placeholder="Select year"
        [clearable]="false"
        [disabled]="false"
        (ngModelChange)="setYear($event)"
      />
    </div>
    <div class="col-span-2 @lg:col-span-1">
      <label class="text-sm">Packing&nbsp;week</label>
      <ng-select
        id="week"
        [(ngModel)]="displayWeek"
        [ngModelOptions]="{ standalone: true }"
        [items]="displayWeeks"
        bindLabel="label"
        bindValue="value"
        [multiple]="false"
        [searchable]="false"
        [virtualScroll]="true"
        placeholder="Select packing week"
        [clearable]="false"
        [disabled]="false"
        (ngModelChange)="setWeek($event)"
      />
    </div>
  </div>
}

@if (displayMultiSelect === false) {
  <div
    (click)="onWeekPickerTriggerClick($event)"
    tabindex="0"
    class="cursor-pointer select-none whitespace-nowrap rounded border bg-white px-3 py-2"
  >
    {{ ngModel }}
  </div>
  <p-popover
    #weekPickerPopover
    styleClass="[&_.p-popover-content]:!p-0"
    (onHide)="closeWeekpicker()"
  >
    <div class="grid" [ngClass]="showYears ? 'grid-cols-2' : 'grid-cols-1'">
      @if (showYears) {
        <div>
          <h3
            class="relative m-0 block border-b p-1 text-center font-semibold before:absolute before:inset-0 before:left-unset before:block before:w-px before:bg-slate-200"
          >
            Year
          </h3>
          <div class="h-24 overflow-y-auto" #yearSelector>
            @for (y of years; track y.value) {
              <div
                id="{{ uniqueID }}-{{ y.value }}"
                class="mr-0.5 cursor-pointer p-1 text-center"
                [ngClass]="{
                  'bg-steel-blue-500 text-white': selectedYear === y.value,
                  'hover:bg-steel-blue-600':
                    !y.disabled && selectedYear === y.value,
                  'hover:bg-[#f5faff]': selectedYear !== y.value && !y.disabled,
                  'cursor-default text-gray-400': y.disabled,
                }"
                (click)="!y.disabled && setYear(y.value)"
              >
                {{ y.value }}
              </div>
            }
          </div>
        </div>
      }
      <div>
        <h3 class="m-0 block border-b p-1 text-center font-semibold">Week</h3>
        <div class="h-24 overflow-y-auto" #weekSelector>
          @for (w of weeks; track w.value) {
            <div
              id="{{ uniqueID }}-{{ w.value }}"
              class="mr-0.5 cursor-pointer p-1 text-center"
              [ngClass]="{
                'bg-steel-blue-500 text-white': selectedWeek === w.value,
                'hover:bg-steel-blue-600':
                  !w.disabled && selectedWeek === w.value,
                'hover:bg-[#f5faff]': selectedWeek !== w.value && !w.disabled,
                'cursor-default text-gray-400': w.disabled,
              }"
              (click)="!w.disabled && setWeek(w.value)"
            >
              {{ w.value }}
            </div>
          }
        </div>
      </div>
      <div
        class="col-span-2 flex items-center justify-between gap-2 border-t p-1"
      >
        <div
          class="cursor-pointer rounded p-1"
          [ngClass]="{
            'cursor-default text-gray-400': lastWeekDisabled,
            'hover:bg-steel-blue-50 hover:text-steel-blue-600':
              !lastWeekDisabled,
          }"
          (click)="!lastWeekDisabled && previousWeek()"
        >
          Last Week
        </div>
        <div
          class="cursor-pointer rounded p-1"
          [ngClass]="{
            'cursor-default text-gray-400': thisWeekDisabled,
            'hover:bg-steel-blue-50 hover:text-steel-blue-600':
              !thisWeekDisabled,
          }"
          (click)="!thisWeekDisabled && thisWeek()"
        >
          This Week
        </div>
        <div
          class="cursor-pointer rounded p-1"
          [ngClass]="{
            'cursor-default text-gray-400': nextWeekDisabled,
            'hover:bg-steel-blue-50 hover:text-steel-blue-600':
              !nextWeekDisabled,
          }"
          (click)="!nextWeekDisabled && nextWeek()"
        >
          Next Week
        </div>
      </div>
    </div>
  </p-popover>
}
